import React, { useContext } from "react";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import WhatYouGetTile from "./WhatYouGetTile";

const WhatYouGet = ({ classes }) => {
  const language = useContext(LanguageContext);

  return (
    <div className={classes.whatYouGetSection}>
      <div className={classes.whatYouGetWrapper}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item>
            <Typography variant={"h5"} style={{ fontWeight: "bold" }}>
              {messages["landing.whatYouGet"][language]}
            </Typography>
          </Grid>
        </Grid>

        <WhatYouGetTile
          classes={classes}
          title={messages["landing.msg1.title"][language]}
          text={messages["landing.msg1.text"][language]}
          image={"../../icons/WhatYouGet1.png"}
        />
        <WhatYouGetTile
          classes={classes}
          title={messages["landing.msg2.title"][language]}
          text={messages["landing.msg2.text"][language]}
          image={"../../icons/WhatYouGet2.jpeg"}
        />
        <WhatYouGetTile
          classes={classes}
          title={messages["landing.msg3.title"][language]}
          text={messages["landing.msg3.text"][language]}
          image={"../../icons/WhatYouGet3.jpeg"}
        />
      </div>
    </div>
  );
};

export default WhatYouGet;
